(function () {
  "use strict";

  angular.module('branding', [
    'trainerWebApp.services',
    'trainerWebApp.resources',
    'trainerWebApp.controllers',
    'colorpicker.module',
    'ngAnimate',
    'ngRoute',
    'ngResource'
  ]);

  angular
    .module('branding')
    .value('bodyColorOptions', [
      {
        mtype: 102000100,
        name: 'blue',
        color: '#DEF2F8',
        hide: false,
        disabled: false
      },
      {
        mtype: 102000200,
        name: 'green',
        color: '#D0F3D7',
        hide: false,
        disabled: false
      },
      {
        mtype: 102000300,
        name: 'orange',
        color: '#FDF1D8',
        hide: false,
        disabled: false
      },
      {
        mtype: 0,
        name: 'plain',
        color: '#FFFFFF',
        hide: false,
        disabled: false
      }
    ])

    .value('publicPagesPro', [
      {
        name: 'blue',
        url: [
          'images/publicPages/portal_login_page_blue.jpg',
          'images/publicPages/course_public_page_blue.jpg',
          'images/publicPages/catalog_public_page_blue.jpg',
          'images/publicPages/portal_reg_page_blue.jpg',
          'images/publicPages/trainee_dashboard_page_blue.jpg'
        ]
      },
      {
        name: 'green',
        url: [
          'images/publicPages/portal_login_page_green.jpg',
          'images/publicPages/course_public_page_green.jpg',
          'images/publicPages/catalog_public_page_green.jpg',
          'images/publicPages/portal_reg_page_green.jpg',
          'images/publicPages/trainee_dashboard_page_green.jpg'
        ]
      },
      {
        name: 'orange',
        url: [
          'images/publicPages/portal_login_page_orange.jpg',
          'images/publicPages/course_public_page_orange.jpg',
          'images/publicPages/catalog_public_page_orange.jpg',
          'images/publicPages/portal_reg_page_orange.jpg',
          'images/publicPages/trainee_dashboard_page_orange.jpg'
        ]
      },
      {
        name: 'plain',
        url: [
          'images/publicPages/portal_login_page_none.jpg',
          'images/publicPages/course_public_page_none.jpg',
          'images/publicPages/catalog_public_page_none.jpg',
          'images/publicPages/portal_reg_page_none.jpg',
          'images/publicPages/trainee_dashboard_page_none.jpg'
        ]
      }
    ])

    .value('publicPagesBasic', [
      {
        name: 'blue',
        url: [
          'images/publicPages/portal_login_page_blue.jpg',
          'images/publicPages/course_public_page_blue.jpg',
          'images/publicPages/portal_reg_page_blue.jpg',
          'images/publicPages/trainee_dashboard_page_blue.jpg'
        ]
      },
      {
        name: 'green',
        url: [
          'images/publicPages/portal_login_page_green.jpg',
          'images/publicPages/course_public_page_green.jpg',
          'images/publicPages/portal_reg_page_green.jpg',
          'images/publicPages/trainee_dashboard_page_green.jpg'
        ]
      },
      {
        name: 'orange',
        url: [
          'images/publicPages/portal_login_page_orange.jpg',
          'images/publicPages/course_public_page_orange.jpg',
          'images/publicPages/portal_reg_page_orange.jpg',
          'images/publicPages/trainee_dashboard_page_orange.jpg'
        ]
      },
      {
        name: 'plain',
        url: [
          'images/publicPages/portal_login_page_none.jpg',
          'images/publicPages/course_public_page_none.jpg',
          'images/publicPages/portal_reg_page_none.jpg',
          'images/publicPages/trainee_dashboard_page_none.jpg'
        ]
      }
    ])

    .value('logoStatus', {
      replaced: 'replaced',
      removed: 'removed',
      unchanged: 'unchanged'
    })

    .value('dto', {
      "name": "",
      "description": null,
      "logoUrl": null,
      "logoFileName": null,
      "logoFileId": null,
      "logoStatus": null,
      "colorScheme": 102000100,
      "headerBackgroundColor": "#ffffff",
      "headerTextColor": "#000000",
      "headerLinkColor": "#0000FF"
    });

})();
